import React, { useState } from "react";
import { useField, useFormikContext } from "formik";
import TextField from "@mui/material/TextField";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, min } from "date-fns";

const DatePickerField = ({ name, minDate, maxDate, ...otherProps }) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  const [open, setOpen] = useState(false);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        label={otherProps.label}
        value={field.value || null}
        onChange={(newValue) => {
          if (newValue) {
            const today = new Date();
            const selectedDate = new Date(newValue);

            // Strip time from both for date-only comparison
            today.setHours(0, 0, 0, 0);
            selectedDate.setHours(0, 0, 0, 0);

            if (selectedDate > today) {
              // Optionally show a message to the user here
              return;
            }

            const formattedDate = format(selectedDate, "yyyy-MM-dd");
            setFieldValue(name, formattedDate);
            setOpen(false); // Close the calendar on a valid selection
          } else {
            setFieldValue(name, "");
          }
        }}
        minDate={minDate ? new Date(minDate) : new Date()}
        maxDate={maxDate ? min([new Date(maxDate), new Date()]) : new Date()}
        inputFormat="dd/MM/yyyy"
        required={otherProps.required}
        renderInput={(params) => (
          <TextField
            {...params}
            onClick={() => setOpen(true)} // Open calendar when clicking anywhere on the field
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setOpen(!open);
              }
            }}
            inputProps={{
              ...params.inputProps,
              readOnly: true, // keep it read-only to prevent manual edits
            }}
            required={otherProps.required}
            fullWidth
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default DatePickerField;
